import { AdyenDisputeImportResult } from '../types/adyenDisputeImport';

export function formatAdyenImportResult(result: AdyenDisputeImportResult): string {
  const parts = [`${result.imported} dispute${result.imported === 1 ? '' : 's'} imported`];
  if (result.updated > 0) parts.push(`${result.updated} updated`);
  if (result.skipped > 0) parts.push(`${result.skipped} unchanged`);
  if (result.fraudCount > 0) parts.push(`${result.fraudCount} fraud notification${result.fraudCount === 1 ? '' : 's'} skipped`);
  return parts.join(', ');
}
